export function isClosedBookEmbedFlag(value) {
  return value === true || value === 1 || value === '1' || value === 'true' || value === 'on';
}
